import { createContext, useContext } from 'react';

import { EMPTY_ARRAY, EMPTY_FUNCTION } from '../../../constants';
import { DropdownContextProps } from '../types';

export const DropdownContext = createContext<DropdownContextProps<any>>({
  label: '',
  information: '',
  padding: '0px',
  height: '32px',
  width: '100%',
  options: EMPTY_ARRAY,
  extend: false,
  selected_index: -1,
  keyboard_index: -1,
  option_key: '',
  placeholder: '',
  auto_focus: false,
  autosize: false,
  value: '',
  prefix: '',
  suffix: '',
  typed_value: '',
  loading: false,
  is_open: false,
  disabled: false,
  error: false,
  clear: false,
  filterable: false,
  is_focused: false,
  transparent: false,
  onClickField: EMPTY_FUNCTION,
  onMouseDown: EMPTY_FUNCTION,
  onClick: EMPTY_FUNCTION,
  onKeyDown: EMPTY_FUNCTION,
  onChange: EMPTY_FUNCTION,
  onBlur: EMPTY_FUNCTION,
  onFocus: EMPTY_FUNCTION,
  onSelect: EMPTY_FUNCTION,
  onClose: EMPTY_FUNCTION,
  onRemove: EMPTY_FUNCTION,
});

export const useDropdownContext = <T extends Record<string, any>>() =>
  useContext(DropdownContext) as DropdownContextProps<T>;
